var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-view-wrapper"},[(_vm.$slots.header)?_c('div',{staticClass:"app-view-wrapper__header"},[_vm._t("header")],2):_vm._e(),(_vm.$slots.content)?_c('div',{staticClass:"app-view-wrapper__content"},[_vm._t("content")],2):_vm._e(),(_vm.$slots.footer)?_c('div',{staticClass:"app-view-wrapper__footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }